export default "__VITE_ASSET__AGodwnGr__"